import React from 'react';
import PropTypes from 'prop-types';
import { getFares } from '../../../_integrations/everymundo/carPackage';
import FaresCarouselBackgroundImageContainer from '../FaresCarouselBackgroundImageContainer';

const FlightsCarsPackagesCarouselContainer = (props) => (
  <FaresCarouselBackgroundImageContainer {...props} getFares={getFares} />
);

FlightsCarsPackagesCarouselContainer.componentName = 'FlightsCarsPackagesCarouselContainer';

FlightsCarsPackagesCarouselContainer.propTypes = {
  /**
   * Parameters tracking
   */
  tracking: PropTypes.objectOf(PropTypes.any)
};

FlightsCarsPackagesCarouselContainer.defaultProps = {
  tracking: {
    flexibleDates: false,
    passengerCount: 1,
    promoCode: 'EVERYMUNDO',
    eventType: 'flightsCarsPackagesCarouselContainer'
  }
};

export default FlightsCarsPackagesCarouselContainer;
